<template>
    <div>
        <v-form
            ref="form"
            v-model="valid"
            :enctype="enctype"
            lazy-validation
            @submit.prevent="submit"
        >
            <!--<v-row>
         Titulo
        <v-col cols="12" class="pb-1">
          <v-row align="center" justify="center" class="pb-0 mb-0 color">
            <strong>{{ loginTitle }}</strong>
          </v-row>
        </v-col>
      </v-row>-->
            <!-- Iconos, Text Fields y button-->
            <v-row align="center" justify="end" class="pa-0 ma-0">
                <v-col cols="1" class="pt-5">
                    <v-icon color="azul" size="15" class="mx-2">
                        mdi-account
                    </v-icon>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                        v-model.lazy="username"
                        label="Usuario"
                        name="username"
                        :rules="[rules.required()]"
                        :readonly="loading"
                        required
                    />
                </v-col>
                <v-col cols="1" class="pt-4">
                    <v-icon size="15" color="azul" class="mx-2">
                        mdi-lock
                    </v-icon>
                </v-col>
                <v-col cols="3">
                    <!-- :append-icon="showPass ? 'visibility_off' : 'visibility'"  
                  @click:append="showPass = !showPass"
            ---- Ver si lo quieren-->
                    <v-text-field
                        v-model.lazy="password"
                        label="Contraseña"
                        name="password"
                        required
                        :type="showPass ? 'text' : 'password'"
                        :rules="[rules.required()]"
                        :readonly="loading"
                    />
                </v-col>

                <v-col cols="3" class="">
                    <v-btn
                        :disabled="loading"
                        :loading="loading"
                        color="azul"
                        class="white--text text-capitalize"
                        type="submit"
                        small
                        height="25px"
                        width="70px"
                    >
                        Ingresar
                    </v-btn>
                </v-col>
            </v-row>
            <!--<v-row v-for="(u, index) in userHelp" :key="index" class="pa-0">
                <v-col align="center" justify="center" class="pa-0 ma-0 pb-1">
                    <h5>
                        <a :href="'/' + u.link" class="link color">
                            {{ u.text }}
                        </a>
                    </h5>
                </v-col>
            </v-row>-->
        </v-form>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import formRules from '../utils/formRules';

export default {
    name: 'LoginNavbar',
    components: {},
    props: {
        enctype: { type: String }, // default: "application/x-www-form-urlencoded"
        reset: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        error: null,
        showPass: false,
        password: '',
        username: '',
        valid: false,
        loginTitle: 'Acceso clientes',
        userHelp: [
            {
                label: 'crear',
                text: '¿ Desea crear una cuenta ?',
                link: 'contact'
            },
            {
                label: 'olvidar',
                text: '¿ Olvidó su contraseña ?',
                link: 'contact'
            }
        ]
    }),
    computed: {
        ...mapState('auth', ['loading']),
        ...mapGetters(['isLoggedIn']),
        rules: () => formRules
    },
    methods: {
        ...mapActions('auth', ['signIn']),

        async submit(formValid) {
            this.error = null;
            if (!formValid || this.loading) {
                return;
            }

            const { error } = await this.signIn({
                username: this.username,
                password: this.password
            });
            if (this.isLoggedIn) {
                // this.$router.replace({ name: "Drogueria" });
            } else {
                this.error = error; // ||"Usuario o Contraseña incorrecto.";
            }
        }
    }
};
</script>
<!--Tengo que cambiar el .color, no se como hacerlo en el h4 -->
<style scoped>
.color {
    color: #184087;
}
.link {
    text-decoration: none;
}
</style>
